import React, { useState } from 'react';
import {
  Button,
  Form,
  Grid,
  Header,
  Segment,
  Message,
} from 'semantic-ui-react';
import { requestB2CPasswordReset } from '../services/AuthApi';

const PasswordResetForm = (props) => {
  const [email, setEmail] = useState('');

  const [formSuccess, setFormSuccess] = useState(false);

  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    // Basic validation
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    
    setIsLoading(true);
    setError('');
    
    try {
      await requestB2CPasswordReset(email);
      setFormSuccess(true);
    } catch (err) {
      console.error('Failed to send password reset email:', err);
      setError(err.response?.data?.message || 'Failed to send password reset email. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundImage: 'url("/images/shutterstock_461838712.jpg")',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
    >
      <Grid
        textAlign="center"
        style={{
          height: '100vh',
          margin: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
        }}
        verticalAlign="middle"
      >
        <Grid.Column
          style={{
            maxWidth: 450,
            backgroundColor: '#fff',
            padding: '3em',
          }}
        >
          <Header as="h2" textAlign="center">
            <Header.Content>Reset Password</Header.Content>
          </Header>
          <Form size="large" success={formSuccess} error={!!error}>
            <Segment style={{ border: '0', boxShadow: '0 0 0 0' }}>
              <Message
                success
                header="Successfully sent a Reset-Password Email"
                content="Check your emails and follow the link provided"
              />
              {error && (
                <Message error content={error} />
              )}
              <Form.Input
                fluid
                icon="user"
                iconPosition="left"
                placeholder="E-mail address"
                value={email}
                onChange={(event) =>
                  setEmail(
                    event.target.value
                      .toLowerCase()
                      .replace(/\s/g, ''),
                  )
                }
              />
              <Button
                color="green"
                fluid
                size="large"
                onClick={handleSubmit}
                loading={isLoading}
                disabled={isLoading}
              >
                {isLoading ? 'Sending...' : 'Send a Reset-Password Email'}
              </Button>
            </Segment>
          </Form>
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default PasswordResetForm;
